<div class="workspace">

    <!-- HEADER -->
    <header class="workspace-header">

        <div class="header-left">

            <div class="header-icon">
                <i class="fas fa-file-signature"></i>
            </div>

            <div>
                <h4>Calibración de firmas.</h4>
                <span>Seleccione un documento y coloque las áreas de firma.</span>
            </div>

        </div>

        <div class="header-right">

            <div class="autosave">

                <i class="fas fa-cloud-upload-alt"></i>

                <div>

                    <small>Autoguardado</small>

                    <strong>{{ hora }}:{{ minutos }}:{{ segundos }}</strong>

                </div>

            </div>

        </div>

    </header>

    <!-- LISTA DE DOCUMENTOS -->
    <section class="documents-bar">

        <app-file-list [documentData]="loteDetalleUrls" (fileSelected)="selectDocument($event)">
        </app-file-list>

    </section>

    <!-- VISOR -->
    <main class="viewer-container">

        <div class="viewer-card">

            <app-file-viewer [url_document]="documentPdfUrl" [certificado]="certificado"
                [listCertificado]="listCertificados" [firma_esgrupo]="es_grupo" [read_only]="readonly"
                [usa_plantilla]="usa_plantilla" (addCertificado)="onAddCertificado($event)"
                (deleteCertificado)="onDeleteCertificado($event)">
            </app-file-viewer>

        </div>

    </main>

    <!-- FOOTER -->

    <footer class="workspace-footer">

        <div class="footer-info">

            <i class="fas fa-shield-alt"></i>

            <span>
                Todos los cambios se guardan automáticamente.
            </span>

        </div>

        <button class="btn-finalizar" (click)="saveAreas()">

            <i class="fas fa-check-circle me-2"></i>

            Finalizar proceso

        </button>

    </footer>

</div>